import ButtonBasic from "@rentiohq/shared-frontend/dist/components/components/ButtonBasic";
import Spacer, {
  ESpacerWeight,
} from "@rentiohq/shared-frontend/dist/components/components/Spacer";
import signUpSchemas from "@rentiohq/shared-frontend/dist/forms/signUp";
import * as signUpActions from "@rentiohq/shared-frontend/dist/forms/signUp/schema.signUp.actions";
import * as authSelectors from "@rentiohq/shared-frontend/dist/redux/auth/auth.selectors";
import { createForm } from "@rentiohq/shared-frontend/dist/redux/form/form.actions";
import { generateFormId } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import {
  ECaptchaVersion,
  ETacPlatform,
} from "@rentiohq/shared-frontend/dist/types/auth.types";
import {
  getLocale,
  getLocalizedText,
} from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { default as React } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { Navigate } from "react-router-dom";
import { IRootState } from "redux/reducers";
import FormMultistep from "../../../../components/FormMultistep";
import InfoHeader from "../../../../components/InfoHeader";
import Page from "../../../../components/Page";
import { getReferrer } from "../../../../utils/navigation.utils";
import * as S from "./SignUp.styles";

export const SignUp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const user = useSelector((state: IRootState) => authSelectors.getUser(state));

  const [formId] = React.useState(generateFormId());
  const [preventRedirect, setPreventRedirect] = React.useState(false);

  React.useEffect(() => {
    dispatch(
      createForm({
        formId,
        schemas: signUpSchemas({}),
        withSummary: false,
      }),
    );
  }, []);

  // Event handlers
  const handleCustomSuccessAction = () => {
    setPreventRedirect(false);
  };

  const handlePressTac = () => {
    navigate("/terms-and-conditions", {
      state: { referrer: getReferrer(location) },
    });
  };

  const handlePressSignIn = () => {
    navigate("/auth/signin", {
      state: { referrer: getReferrer(location) },
    });
  };

  // Render
  const renderRedirect = () => {
    if (preventRedirect) {
      return null;
    }

    if (!user) {
      return null;
    }

    return <Navigate to={getReferrer(location)} />;
  };

  const renderExtraLeadingControls = () => (
    <>
      <S.ButtonInfo>
        <span>{getLocalizedText("auth.sign_up.tac.message")} </span>
        <ButtonBasic
          title={getLocalizedText("auth.sign_up.tac.link")}
          onPress={handlePressTac}
        />
        <span>{"."}</span>
        <Spacer weight={ESpacerWeight.W16} />
      </S.ButtonInfo>
    </>
  );

  const renderExtraTrailingControls = () => (
    <>
      <Spacer weight={ESpacerWeight.W16} />
      <S.ButtonInfo>
        <span>{getLocalizedText("auth.sign_up.login.title")} </span>
        <ButtonBasic
          title={getLocalizedText("auth.sign_up.login.cta")}
          onPress={handlePressSignIn}
        />
      </S.ButtonInfo>
    </>
  );

  return (
    <>
      {renderRedirect()}
      <Page>
        <InfoHeader
          title={getLocalizedText("auth.sign_up.title")}
          body={getLocalizedText("auth.sign_up.body")}
        />
        <S.FormWrap>
          <FormMultistep
            formId={formId}
            // @ts-ignore state match
            isPerformingSubmitActionSelector={signUpActions.isPerformingSubmitActionSelector()}
            // @ts-ignore state match
            performingSubmitActionResultSelector={signUpActions.performingSubmitActionResultSelector()}
            // @ts-ignore state match
            performingSubmitActionErrorSelector={signUpActions.performingSubmitActionErrorSelector()}
            submitActionCreator={signUpActions.submitActionCreator(
              getLocale(),
              ETacPlatform.App,
              ECaptchaVersion.Legacy,
            )}
            customSuccessAction={handleCustomSuccessAction}
            submitTitle={getLocalizedText("system.register.title")}
            renderExtraLeadingControls={renderExtraLeadingControls}
            renderExtraTrailingControls={renderExtraTrailingControls}
          />
        </S.FormWrap>
      </Page>
    </>
  );
};
